module.exports = __webpack_public_path__ + "img/RU.74f13554.svg";